/**
 * Contrat d'API HTTP — DTO partagés app <-> API.
 *
 * Uniquement des formes de données. La validation d'entrée (zod) et
 * l'implémentation vivent côté `@silex/api`.
 */
/**
 * Longueur minimale d'un mot de passe de compte titulaire.
 *
 * LOT 3.5 (MOB-AUT-SUP-02) — ce nombre était écrit QUATRE fois côté serveur
 * (`auth.routes.ts` deux fois, `admin.routes.ts`, et le message qui
 * l'accompagne) et une cinquième fois côté client, dans la condition qui
 * active le bouton d'envoi. Cinq copies d'une règle que le parent découvre en
 * la heurtant : le formulaire refusait sa saisie sans jamais dire pourquoi,
 * parce que le gabarit du champ — le seul endroit où le chiffre apparaissait à
 * l'écran — disparaît à la première frappe.
 *
 * Même raison que `accord.ts` et `phrase-a-retenir.ts` : une règle que les
 * deux bouts de la chaîne appliquent vit ici, une fois.
 */
export const MOT_DE_PASSE_MIN = 8;
/**
 * La forme d'une source d'inscription : lettres, chiffres et tiret, 60
 * caractères au plus. Elle se compare en minuscules.
 */
export const SOURCE_INSCRIPTION = /^[A-Za-z0-9-]{1,60}$/;
//# sourceMappingURL=api.js.map